import { z } from 'zod';
import { uuidSchema } from './comum.ts';
import { apenasDigitos } from './documento.ts';

/**
 * Endereço de pessoa (`.spec/016`, "Endereço — campos independentemente
 * opcionais").
 *
 * Fica em arquivo próprio porque não é de empresa nem de fornecedor: é o mesmo
 * conjunto de seis colunas em `pessoas` e em `obras`. Mantido dentro do
 * contrato de empresa, o segundo cadastro copiaria a definição — e as duas
 * cópias divergiriam no primeiro ajuste de tamanho de campo.
 *
 * Nenhum campo é obrigatório e não há vínculo entre eles: é válido gravar só a
 * cidade, só o CEP, ou nada. O único `CHECK` é de **formato** do CEP.
 */

/** CEP: oito dígitos ou nulo. String vazia vinda do formulário vira `null`. */
const cepSchema = z
  .string()
  .transform(apenasDigitos)
  .refine((cep) => cep.length === 0 || cep.length === 8, 'CEP deve ter 8 dígitos.')
  .transform((cep) => (cep.length === 0 ? null : cep));

/** Campo de texto opcional: string vazia vinda do formulário vira `null`. */
export const textoOpcional = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .transform((v) => (v.length === 0 ? null : v))
    .nullable()
    .prefault(null);

export const enderecoSchema = z.object({
  endereco: textoOpcional(200),
  numero: textoOpcional(20),
  complemento: textoOpcional(100),
  bairro: textoOpcional(100),
  cidadeId: uuidSchema.nullable().prefault(null),
  cep: cepSchema.nullable().prefault(null),
});

export type Endereco = z.infer<typeof enderecoSchema>;
